import React, {
  useMemo, useEffect, useState,
} from 'react';
import { useMediaQuery } from 'usehooks-ts';
// import { useNavigate } from 'react-router-dom';
import { IoChevronUpOutline, IoChevronDownOutline } from 'react-icons/io5';
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from '@tanstack/react-table';
import styles from './products-table.module.scss';
import { IProduct } from '~/types/products';

const columns = [{
  header: 'Nom de l\'offre',
  accessorKey: 'name',
}, {
  header: 'Prix salon',
  accessorKey: 'price',
  cell: (row: any) => {
    const price = row.getValue() || '';
    return <span>{(price || 0).toFixed(2)}€</span>;
  },
}, {
  header: 'EAN produit',
  accessorKey: 'ean',
}, {
  header: 'Remise',
  accessorKey: 'discount',
  cell: (row: any) => {
    const discount = row.getValue() || '';
    return <span className={styles.discount}>{(discount * 100 || 0).toFixed(2)}%</span>;
  },
}];

const ProductsTable = (
  {
    products,
    handleSorting,
    // pathToDetail,
  } : {
    products: IProduct[],
    handleSorting: any,
    pathToDetail?: string,
  },
) => {
  const [sorting, setSorting] = useState<any>([]);
  // const navigate = useNavigate();

  useEffect(() => {
    handleSorting(sorting[0]);
  }, [sorting]);

  const data = useMemo(() => products, [products]);
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    onSortingChange: setSorting,
    state: {
      sorting,
    },
  });

  // const onRowClick = (row: Row<IProduct>) => {
  // navigate(pathToDetail ?
  // `${pathToDetail}/${row.original._id}` : `/products/${row.original._id}`);
  // };

  return (
    <div className={styles.productsTable}>
      <table>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  className={styles[header.column.id]}
                  onClick={header.column.getToggleSortingHandler()}
                >
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
                  <div className={styles.sortIcons}>
                    <span className={header.column.getIsSorted() === 'asc' ? styles.active : ''}><IoChevronUpOutline /></span>
                    <span className={header.column.getIsSorted() === 'desc' ? styles.active : ''}><IoChevronDownOutline /></span>
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} className={styles[cell.column.id]}>
                  <p>
                    {flexRender(
                      cell.column.columnDef.cell,
                      {
                        ...cell.getContext(),
                      },
                    )}
                  </p>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const ResponsivProductsTable = (
  {
    products,
    handleSorting,
    pathToDetail,
  } : {
    products: IProduct[],
    handleSorting: any,
    pathToDetail?: string,
  },
) => {
  const isTablet = useMediaQuery('(max-width: 1180px)');
  return (
    <>
      {isTablet ? (
        <ul className={styles.listTablet}>
          {products.map((product: IProduct) => (
            <li key={`product-${product._id}`}>
              <div className={styles.product}>
                <p className={styles.discount}>
                  {(product?.discount || 0).toFixed(2)}%
                </p>
                <p className={styles.name}>{product.name}</p>
                <div className={styles.details}>
                  {/* <p>
                    Référence produit <span>{product.ref}</span>
                  </p>
                  <p>
                    EAN produit <span>{product.ean}</span>
                  </p> */}
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <ProductsTable
          products={products}
          handleSorting={handleSorting}
          pathToDetail={pathToDetail}
        />
      )}
    </>
  );
};

export default ResponsivProductsTable;
